import axios from "axios";
import { propertyAPI } from "../../axios";

export const actions = {
  GetMyCart() {
    return propertyAPI.get(`PropertyCart/My`);
  },
  AddToCart(context, data) {
    return propertyAPI.post(`PropertyCart/Add`, data);
  },
  RemoveFromCart(context, data) {
    return propertyAPI.delete(`PropertyCart/${data}`);
  },
  ClearCart() {
    return propertyAPI.delete(`PropertyCart/Clear`);
  }
};